import {
  ChartWrapper,
  CornerLabel,
  HalfDonutChart as SingleHalfDonut
} from './HalfDonutChart.styles'

export type HalfDonutChartProps = {
  value: number
  colors?: string[]
  backgroundColor?: string
  color?: string
  size?: number
  fontSize?: string
  lineHeight?: string
  leftLabelColor?: string
  rightLabelColor?: string
  displayLeftLabel?: boolean
  displayRightLabel?: boolean
}

const HalfDonutChart = ({
  value,
  colors = ['#FF3D00'],
  backgroundColor = 'transparent',
  color = '#fff',
  size = 300,
  fontSize = '20px',
  lineHeight = '24px',
  leftLabelColor = '#fff',
  rightLabelColor = '#fff',
  displayRightLabel = true,
  displayLeftLabel = true
}: HalfDonutChartProps) => {
  const fillColor = colors[0] || '#FF3D00'
  const trackColor = colors[1] || 'rgba(0,0,0,0.15)'

  return (
    <ChartWrapper color={color} size={size} style={{ backgroundColor }}>
      <SingleHalfDonut
        $fillColor={fillColor}
        $trackColor={trackColor}
        $percent={value}
        $size={size}
      />
      {displayLeftLabel && (
        <CornerLabel
          $fontSize={fontSize}
          $lineHeight={lineHeight}
          $color={leftLabelColor}
          position='left'
        >{`${value}%`}</CornerLabel>
      )}
      {displayRightLabel && (
        <CornerLabel
          $fontSize={fontSize}
          $lineHeight={lineHeight}
          $color={rightLabelColor}
          position='right'
        >{`${100 - value}%`}</CornerLabel>
      )}
    </ChartWrapper>
  )
}

export default HalfDonutChart
